import { styled } from '@mui/material';

export const Body = styled('div')`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100vh;
  overflow: hidden; // ⬅️ aqui
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  background-color: ${({ theme }) => theme.palette.white.main};
`;

interface GlassProps {
  expanded: boolean;
}

export const GlassContent = styled('div')<GlassProps>`
  position: relative;
  flex: 1;

  ${({ expanded }) =>
    expanded &&
    `
    &::before {
      content: '';
      position: absolute;
      inset: 0;
      backdrop-filter: blur(16px);
      -webkit-backdrop-filter: blur(16px);
      background: rgba(255, 255, 255, 0.08);
      z-index: 999; /* acima dos filhos */
      pointer-events: none;
    }
  `}
`;

export const Blur = styled('div')<GlassProps>`
  z-index: 1;
  width: 100%;

  ${({ expanded }) =>
    expanded &&
    `
  &::before {    
    content: '';
    position: absolute;
    inset: 0;
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    background: rgba(255, 255, 255, 0.08);
    z-index: 999; /* acima dos filhos */
    pointer-events: none;      
  }
`};
`;

interface ContentProps {
  noLeftMargin: boolean;
}

export const Content = styled('div')<ContentProps>`
  display: flex;
  flex-direction: column;
  //width: 100%;
  justify-content: center;
  align-items: flex-start;
  position: relative;
  flex: 1;
  margin-left: ${({ noLeftMargin }) => (noLeftMargin ? '0px' : '30px')};

  /* Telas grandes (desktop) */
  @media (min-width: 1024px) {
    flex-direction: row; /* lado a lado */
    margin-top: 0px;
    //margin-bottom: 50px;
  }

  /* Tablets */
  @media (max-width: 1023px) and (min-width: 768px) {
    flex-direction: row;
    gap: 20px;
  }

  /* Mobile */
  @media (max-width: 767px) {
    flex-direction: column;
    margin-top: 15px;
    margin-bottom: 20px;
    margin-left: ${({ noLeftMargin }) => (noLeftMargin ? '0px' : '15px')};
    justify-content: flex-start;
  }
`;
